import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import Landing from "@/pages/Landing";
import Analyze from "@/pages/Analyze";
import Results from "@/pages/Results";
import Dashboard from "@/pages/Dashboard";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AuthCallback from "@/pages/AuthCallback";
import MentionsLegales from "@/pages/legal/MentionsLegales";
import CGV from "@/pages/legal/CGV";
import Confidentialite from "@/pages/legal/Confidentialite";
import Resiliation from "@/pages/legal/Resiliation";

function AppRouter() {
  const location = useLocation();
  // Detect OAuth callback synchronously during render to avoid race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/analyze" element={<Analyze />} />
      <Route path="/results/:auditId" element={<Results />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/legal/mentions-legales" element={<MentionsLegales />} />
      <Route path="/legal/cgv" element={<CGV />} />
      <Route path="/legal/confidentialite" element={<Confidentialite />} />
      <Route path="/legal/resiliation" element={<Resiliation />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
